/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Temperature_Delta_SetpointInputs */



/**
* | output |
* | --- |
* | "Temperature delta setpoint" |
*
* @param {Temperature_Delta_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const temperature_delta_setpoint = /** @type {((inputs?: Temperature_Delta_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Temperature_Delta_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Temperature delta setpoint")
	return /** @type {LocalizedString} */ ("Consigne delta température")
});